const appEnv = process.env.NEXT_PUBLIC_APP_ENV || process.env.APP_ENV || process.env.NODE_ENV || "development"

/**
 * Công tắc bật/tắt cho phép search engine index site.
 * ENABLE_INDEXING=true  -> robots.txt Allow + meta robots "index, follow"
 * ENABLE_INDEXING=false -> robots.txt Disallow + meta robots "noindex, follow" (mặc định)
 */
const enableIndexing = String(process.env.ENABLE_INDEXING ?? "").trim().toLowerCase() === "true"

export const ENV = {
  appEnv,
  isDev: appEnv === "development",
  isProd: appEnv === "production",
  enableIndexing,
  /** Giá trị dùng khi CMS không set metaRobots (và là giá trị ép buộc khi tắt index) */
  defaultRobots: enableIndexing ? "index, follow" : "noindex, follow",
}
